/**
 * Regular expression patterns used throughout the application.
 * Centralized for consistency and easier maintenance.
 *
 * NOTE: Citation-related regex is in constants/citations.ts (single source of truth)
 */

/**
 * Matches message IDs with token suffixes
 * Example: "msg-123-token-456" → captures "msg-123"
 * Used to deduplicate streaming tokens by stripping the suffix
 */
export const TOKEN_ID_REGEX = /(.*)-token-[^/]+$/;
